export default __webpack_public_path__ + "static/media/mke-zoo-african-lion-hyena.c99614d3.jpg";